"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BffSource = void 0;
var tslib_1 = require("tslib");
var merge_1 = require("../util/merge");
var bernie_logger_1 = require("bernie-logger");
var BffSource = /** @class */ (function () {
    function BffSource(host, logger, forwardedHeaders, forwardedParams) {
        this.host = host;
        this.logger = logger || bernie_logger_1.NOOP_LOGGER;
        this.forwardedHeaders = forwardedHeaders || {};
        this.forwardedParams = forwardedParams || {};
    }
    /**
     * Creates a basic JSON object from the store, excluding
     * any fields provided in `excludedFields`.
     */
    BffSource.prototype.toJSON = function (ignoreAdditionalKeys) {
        if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
        if (!Array.isArray(ignoreAdditionalKeys)) {
            ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
        }
        var regexIgnorePrivate = /^_.+/;
        var simpleObject = tslib_1.__rest(this, []);
        var ignoreKeys = Object.keys(simpleObject)
            .filter(function (key) { return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function'; })
            .concat(ignoreAdditionalKeys, 'logger');
        return (0, merge_1.withoutKeys)(ignoreKeys).merge({}, simpleObject);
    };
    return BffSource;
}());
exports.BffSource = BffSource;
//# sourceMappingURL=bff-source.js.map